import * as React from 'react';
import { connect } from 'react-redux';
import { Field } from '@progress/kendo-react-form';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { FilterForm, WrapLayout, TextBox, DropDown } from '../../../ui';
import {
  filterGeneralCompetencyEvents,
  clearGeneralCompetencyEventsFilter,
  loadGeneralCompetencyEventStatuses
} from '../actions/general-competency-event-list-page-actions';

class GeneralCompetencyEventListFilter extends React.PureComponent {
  componentDidMount() {
    const localizationService = provideLocalizationService(this);
    this.props.loadGeneralCompetencyEventStatuses(localizationService);
  }

  render() {
    const {
      filter,
      clearGeneralCompetencyEventsFilter,
      filterGeneralCompetencyEvents,
      generalCompetencyEventStatuses
    } = this.props;
    const localizationService = provideLocalizationService(this);
    return (
      <FilterForm
        initialValues={filter}
        onSubmit={filterGeneralCompetencyEvents}
        onClear={clearGeneralCompetencyEventsFilter}
        localizationService={localizationService}
        title={localizationService.toLanguageString('grid.filterTitle')}
        uniqueKey={JSON.stringify(filter)}
        render={() => (
          <WrapLayout>
            <Field
              name='keyword'
              width='340px'
              component={TextBox}
              label={localizationService.toLanguageString('custom.search')}
            />
            <Field
              name='status'
              width='340px'
              component={DropDown}
              label={localizationService.toLanguageString('generalCompetencyEvent.status')}
              textField='name'
              dataItemKey='id'
              data={generalCompetencyEventStatuses}
            />
          </WrapLayout>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  filter: state.generalCompetencyEventListPage.filter,
  generalCompetencyEventStatuses: state.generalCompetencyEventListPage.generalCompetencyEventStatuses
});

const mapDispatchToProps = dispatch => ({
  filterGeneralCompetencyEvents: (payload) => dispatch(filterGeneralCompetencyEvents(payload)),
  clearGeneralCompetencyEventsFilter: () => dispatch(clearGeneralCompetencyEventsFilter()),
  loadGeneralCompetencyEventStatuses: (localizationService) => dispatch(loadGeneralCompetencyEventStatuses(localizationService))
});

registerForLocalization(GeneralCompetencyEventListFilter);

export default connect(mapStateToProps, mapDispatchToProps)(GeneralCompetencyEventListFilter);
